module.exports = require('./lib/websocket');


//////////////////
// WEBPACK FOOTER
// ./~/websocket/index.js
// module id = 449
// module chunks = 0 1 2